"use client";

import type { FC } from "react";
import { useSelector } from "@tanstack/react-store";

import {
  notificationsStore,
  notificationsDispatch,
} from "libs/state/src/lib/stores/tanstack/notifications/notifications.store";
import { Sonner } from "../../feedback";
import { Stack } from "../../layout";
import { TNotificationsProps } from "./Notifications.config";

export const Notifications: FC<TNotificationsProps>= ({ className, ...props }) => {
  const activeNotifications = useSelector(
    notificationsStore,
    ({ notifications }) => notifications,
  );

  return (
    <Stack {...props} data-component="Notifications" className={className}>
      { activeNotifications.map(({ id, type, ...notification }) => (
        <Sonner
          {...notification}
          key={id}
          variant={type}
          onDismiss={() => notificationsDispatch.removeNotification(id)}
        />
      )) }
    </Stack>
  );
};
